import { createIcons, icons } from 'lucide';
import Iconify from '@iconify/iconify';

window.Iconify = Iconify;
window.lucide = { createIcons, icons };

export function refreshIcons(root = document) {
    createIcons({
        root,
        icons,
        nameAttr: 'data-lucide',
        attrs: {
            class: "lucide"
        }
    });

    if (Iconify && Iconify.scan) {
        Iconify.scan(root);
    }
}

export function safeInitLucide() {
    refreshIcons();
}
window.refreshIcons = refreshIcons;
